import {ContentInfusionData} from '../types/travel.ts'
import {ContentInfusionStyle1} from "./partials/ContentInfusionStyle1.tsx";
import {ContentInfusionStyle2} from "./partials/ContentInfusionStyle2.tsx";
import "../styles/components/ContentInfusionComponent.css"
import {ContentInfusionStyle3} from "./partials/ContentInfusionStyle3.tsx";
import {ContentInfusionStyleBasic} from "./partials/ContentInfustionBasic.tsx";

interface ContentInfusionProps {
    data: ContentInfusionData;
}

export function ContentInfusionComponent({data}: ContentInfusionProps) {
    if (!data) return null;

    const isWithinDateRange = (): boolean => {
        const now = new Date();
        const fromDate = new Date(data.datetime_from);
        const toDate = new Date(data.datetime_to);

        return now >= fromDate && now <= toDate;
    };

    if (!isWithinDateRange()) {
        return null;
    }

    const {style} = data;
    const styleValue: string = style?.value || 'basic';

    const isStyleBasic: boolean = styleValue === 'basic';
    const isStyle1: boolean = styleValue === '1';
    const isStyle2: boolean = styleValue === '2';
    const isStyle3: boolean = styleValue === '3';

    return (
        <>
            {isStyleBasic && (<ContentInfusionStyleBasic data={data}/>)}
            {isStyle1 && (<ContentInfusionStyle1 data={data}/>)}
            {isStyle2 && (<ContentInfusionStyle2 data={data}/>)}
            {isStyle3 && (<ContentInfusionStyle3 data={data}/>)}
        </>
    )
}
